import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const faqs = [
  {
    question: "Is Khatabook clone completely free to use?",
    answer: "Yes, the basic ledger management features are 100% free for all MSMEs. We believe in empowering small businesses without upfront costs. Premium features may be available as optional add-ons."
  },
  {
    question: "Is my business data safe and secure?",
    answer: "Absolutely. We use enterprise-grade encryption and automated daily backups to ensure your data is always safe. Your data is stored securely in the cloud and can only be accessed by you via OTP verification."
  },
  {
    question: "Can I use it on multiple devices?",
    answer: "Yes! You can log into your account from any smartphone, tablet, or desktop computer. Your data synchronizes instantly across all your devices in real-time."
  },
  {
    question: "How do automated payment reminders work?",
    answer: "Once you set up a reminder for a pending 'You Got' transaction, the system automatically sends polite SMS and WhatsApp notifications to your customers with a secure UPI payment link on the due date."
  },
  {
    question: "Can I generate PDF reports for GST filing?",
    answer: "Yes, you can generate and download comprehensive day books, customer statements, and monthly transaction reports in PDF or Excel format, making tax filing and accounting much easier."
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white pt-20 relative overflow-hidden font-sans">
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-[600px] h-[600px] bg-gradient-to-tr from-blue-50 to-indigo-50 rounded-full blur-[100px] opacity-60 pointer-events-none"></div>
      
      <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
        <div className="mx-auto max-w-4xl text-center mb-10">
          <h2 className="text-[13px] font-bold uppercase tracking-wide text-[#dc343b] mb-3">Support & Help</h2>
          <p className="text-3xl font-extrabold tracking-tight text-[#111827] sm:text-[2rem]">
            Frequently asked questions
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-gray-500 font-medium max-w-2xl mx-auto">
            Everything you need to know about the product and billing. Can't find the answer you're looking for? Please chat to our friendly team.
          </p>
        </div>

        <div className="mx-auto max-w-full divide-y divide-gray-100">
          {faqs.map((faq, index) => (
            <div key={index} className="py-6">
              <button
                onClick={() => toggleFAQ(index)}
                className="flex w-full items-center justify-between text-left focus:outline-none group"
              >
                <span className={`text-[17px] font-semibold transition-colors duration-200 ${openIndex === index ? 'text-[#dc343b]' : 'text-gray-900 group-hover:text-[#dc343b]'}`}>
                  {faq.question}
                </span>
                <span className="ml-6 flex h-7 items-center">
                  <motion.div
                    animate={{ rotate: openIndex === index ? 180 : 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  >
                    <ChevronDownIcon 
                      className={`h-5 w-5 ${openIndex === index ? 'text-[#dc343b]' : 'text-gray-400 group-hover:text-gray-500'}`} 
                      aria-hidden="true" 
                    />
                  </motion.div>
                </span>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="overflow-hidden"
                  >
                    <p className="pt-4 text-base leading-7 text-gray-600 pr-12">
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
